import { Link, useLocation, type LinkProps } from 'react-router-dom'
import { currentPath, type NavFromState } from '@/lib/navHistory'

type Props = Omit<LinkProps, 'state'> & {
  /** Optional short label stored with from (e.g. chain title) */
  fromLabel?: string
  /** If false, do not attach from state (default true) */
  trackFrom?: boolean
  state?: NavFromState & Record<string, unknown>
}

/** Link that records the current route in location.state.from for contextual Back. */
export function FromLink({ trackFrom = true, fromLabel, state, to, ...rest }: Props) {
  const location = useLocation()
  const nextState: NavFromState & Record<string, unknown> = {
    ...(state || {}),
  }
  if (trackFrom) {
    nextState.from = currentPath(location)
    if (fromLabel) nextState.fromLabel = fromLabel
  }
  return <Link to={to} state={nextState} {...rest} />
}
